<template>
  <div class="wrapper">
    <div class="skillbar" :data-percent="score + '%'">
        <div class="skillbar-title">{{skill}}</div>
        <div class="skill-bar-percent">{{year}} {{ $t('resume.years') }}</div>
        <div class="skillbar-bar" :style="'width:' + score + '%'"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillBar",
  props: ['score', 'skill', 'year']
}
</script>

<style lang="scss">
.wrapper {
    position: sticky;
}

.skillbar {
  position: relative;
  display: block;
  width: 100%;
  margin-bottom: 30px;
}

.skillbar-bar:before {
  background: $blackSolid;
  content: "";
  height: 3px;
  position: absolute;
  width: 100%;
  z-index: -1;
}

.skillbar-bar {
  height: 3px;
  width: 0px;
  background: $greenDark;
  transition-property: width, background-color;
}

.skillbar-title {
  color: $green;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
}

.skill-bar-percent {
  float: right;
  display: inline-block;
  color: $green;
  font-size: 11px;
  font-weight: 600;
}

</style>
